/**
 * WPF NavigationCommandRegistry key → entitlement feature + permission.
 * Generated from LedgerVue NavigationCommandRegistry.cs. Feature ids match
 * LedgerVue.Identity.Features (name equals value). Do not invent keys.
 */
import type { PermissionLevel } from './navigationVisibility';

export interface NavigationCommandMeta {
  feature: string;
  permission: PermissionLevel;
}

export const NAVIGATION_COMMAND_REGISTRY: Record<string, NavigationCommandMeta> = {
  SearchPortfolios: { feature: 'SearchPortfolios', permission: 'Read' },
  CreatePortfolio: { feature: 'CreatePortfolio', permission: 'Write' },
  SearchAccounts: { feature: 'SearchAccounts', permission: 'Read' },
  OpenAccount: { feature: 'OpenAccount', permission: 'Read' },
  SearchCustodians: { feature: 'SearchCustodians', permission: 'Read' },
  CreateCustodian: { feature: 'CreateCustodian', permission: 'Write' },
  SearchInstrument: { feature: 'SearchInstrument', permission: 'Read' },
  SearchAllAssets: { feature: 'SearchAllAssets', permission: 'Read' },
  DefineEquity: { feature: 'DefineEquity', permission: 'Write' },
  DefineFixedRateInstrument: { feature: 'DefineFixedRateInstrument', permission: 'Write' },
  DefineZeroCouponBond: { feature: 'DefineZeroCouponBond', permission: 'Write' },
  DefineFloatingRateBond: { feature: 'DefineFloatingRateBond', permission: 'Write' },
  DefineFund: { feature: 'DefineFund', permission: 'Write' },
  DefineCommodity: { feature: 'DefineCommodity', permission: 'Write' },
  DefineCurrency: { feature: 'DefineCurrency', permission: 'Write' },
  DefineFxCurrencyPair: { feature: 'DefineFxCurrencyPair', permission: 'Write' },
  DefineIndexFutures: { feature: 'DefineIndexFutures', permission: 'Write' },
  DefineStockFutures: { feature: 'DefineStockFutures', permission: 'Write' },
  DefineCurrencyFutures: { feature: 'DefineCurrencyFutures', permission: 'Write' },
  DefineCommodityFutures: { feature: 'DefineCommodityFutures', permission: 'Write' },
  DefineIndexOption: { feature: 'DefineIndexOption', permission: 'Write' },
  DefineStockOption: { feature: 'DefineStockOption', permission: 'Write' },
  DefineOptionOnFutures: { feature: 'DefineOptionOnFutures', permission: 'Write' },
  DefineFxOption: { feature: 'DefineFxOption', permission: 'Write' },
  DefineTimeDeposit: { feature: 'DefineTimeDeposit', permission: 'Write' },
  DefineLoan: { feature: 'DefineLoan', permission: 'Write' },
  DefineRealAsset: { feature: 'DefineRealAsset', permission: 'Write' },
  DefineIndex: { feature: 'DefineIndex', permission: 'Write' },
  ClassificationSchemes: { feature: 'ClassificationSchemes', permission: 'Write' },
  SearchDeals: { feature: 'SearchDeals', permission: 'Read' },
  CaptureBuy: { feature: 'CaptureBuy', permission: 'Write' },
  CaptureSell: { feature: 'CaptureSell', permission: 'Write' },
  AiDealCapture: { feature: 'AiDealCapture', permission: 'Write' },
  CaptureFxSpot: { feature: 'CaptureFxSpot', permission: 'Write' },
  CaptureFxForward: { feature: 'CaptureFxForward', permission: 'Write' },
  CaptureBuyOtcOption: { feature: 'CaptureBuyOtcOption', permission: 'Write' },
  CaptureSellOtcOption: { feature: 'CaptureSellOtcOption', permission: 'Write' },
  PlaceTermDeposit: { feature: 'PlaceTermDeposit', permission: 'Write' },
  BreakTermDeposit: { feature: 'BreakTermDeposit', permission: 'Write' },
  DrawdownLoan: { feature: 'DrawdownLoan', permission: 'Write' },
  RepayLoanEarly: { feature: 'RepayLoanEarly', permission: 'Write' },
  CaptureGift: { feature: 'CaptureGift', permission: 'Write' },
  CaptureInheritance: { feature: 'CaptureInheritance', permission: 'Write' },
  CaptureDeposit: { feature: 'CaptureDeposit', permission: 'Write' },
  CaptureWithdraw: { feature: 'CaptureWithdraw', permission: 'Write' },
  ReceiveLong: { feature: 'ReceiveLong', permission: 'Write' },
  ReceiveShort: { feature: 'ReceiveShort', permission: 'Write' },
  DeliverLong: { feature: 'DeliverLong', permission: 'Write' },
  DeliverShort: { feature: 'DeliverShort', permission: 'Write' },
  CaptureIncome: { feature: 'CaptureIncome', permission: 'Write' },
  CaptureExpense: { feature: 'CaptureExpense', permission: 'Write' },
  SearchParticipations: { feature: 'SearchParticipations', permission: 'Read' },
  DefinePrivateEquity: { feature: 'DefinePrivateEquity', permission: 'Write' },
  CapturePrivateEquityActivity: { feature: 'CapturePrivateEquityActivity', permission: 'Write' },
  ReceivePrivateEquity: { feature: 'ReceivePrivateEquity', permission: 'Write' },
  PrivateEquityDashboard: { feature: 'PrivateEquityDashboard', permission: 'Read' },
  RealAssetsDashboard: { feature: 'RealAssetsDashboard', permission: 'Reports' },
  SearchCorporateActions: { feature: 'SearchCorporateActions', permission: 'Read' },
  CaptureCashDividend: { feature: 'CaptureCashDividend', permission: 'Write' },
  CaptureStockDividend: { feature: 'CaptureStockDividend', permission: 'Write' },
  CaptureReturnOfCapital: { feature: 'CaptureReturnOfCapital', permission: 'Write' },
  CaptureCapitalGainsDistribution: { feature: 'CaptureCapitalGainsDistribution', permission: 'Write' },
  CaptureStockSplit: { feature: 'CaptureStockSplit', permission: 'Write' },
  CaptureReverseStockSplit: { feature: 'CaptureReverseStockSplit', permission: 'Write' },
  ClientList: { feature: 'ClientList', permission: 'Read' },
  CreateClient: { feature: 'CreateClient', permission: 'Write' },
  OwnershipDiagramEditor: { feature: 'OwnershipDiagramEditor', permission: 'Write' },
  BeneficialOwnershipDiagram: { feature: 'BeneficialOwnershipDiagram', permission: 'Read' },
  OnboardClient: { feature: 'OnboardClient', permission: 'Write' },
  KycDocumentVerification: { feature: 'KycDocumentVerification', permission: 'Write' },
  ComplianceScreeningQueue: { feature: 'ComplianceScreeningQueue', permission: 'Write' },
  OnboardingReviewQueue: { feature: 'OnboardingReviewQueue', permission: 'Write' },
  RiskQuestionnaireTemplates: { feature: 'RiskQuestionnaireTemplates', permission: 'Write' },
  ComplianceDashboard: { feature: 'ComplianceDashboard', permission: 'Reports' },
  ComplianceRulesDashboard: { feature: 'ComplianceRulesDashboard', permission: 'Reports' },
  CreateComplianceRule: { feature: 'CreateComplianceRule', permission: 'Write' },
  SuggestComplianceRules: { feature: 'SuggestComplianceRules', permission: 'Write' },
  CreateCompliancePolicy: { feature: 'CreateCompliancePolicy', permission: 'Write' },
  HoldingPrices: { feature: 'HoldingPrices', permission: 'Read' },
  HoldingPeriodPrices: { feature: 'HoldingPeriodPrices', permission: 'Read' },
  MarketPricesBrowser: { feature: 'MarketPricesBrowser', permission: 'Read' },
  ForexRatesBrowser: { feature: 'ForexRatesBrowser', permission: 'Read' },
  Prices: { feature: 'Prices', permission: 'Read' },
  FxRates: { feature: 'FxRates', permission: 'Read' },
  CaptureFxRate: { feature: 'CaptureFxRate', permission: 'Write' },
  CapturePrice: { feature: 'CapturePrice', permission: 'Write' },
  ReportExplorer: { feature: 'ReportExplorer', permission: 'Read' },
  SummaryDashboard: { feature: 'SummaryDashboard', permission: 'Read' },
  WhatIfScenarioDashboard: { feature: 'WhatIfScenarioDashboard', permission: 'Reports' },
  HoldingsPositionsDashboard: { feature: 'HoldingsPositionsDashboard', permission: 'Reports' },
  PLDashboard: { feature: 'PLDashboard', permission: 'Reports' },
  PLAnalyticsDashboard: { feature: 'PLAnalyticsDashboard', permission: 'Reports' },
  PerformanceDashboard: { feature: 'PerformanceDashboard', permission: 'Reports' },
  AnalyticsDashboard: { feature: 'AnalyticsDashboard', permission: 'Reports' },
  DynamicDashboard: { feature: 'DynamicDashboard', permission: 'Reports' },
  DashboardDesigner: { feature: 'DashboardDesigner', permission: 'Reports' },
  ConfigurableReporting: { feature: 'ConfigurableReporting', permission: 'Reports' },
  UserDashboardList: { feature: 'UserDashboardList', permission: 'Reports' },
  ClientStatementDashboard: { feature: 'ClientStatementDashboard', permission: 'Reports' },
  TransactionsCashDashboard: { feature: 'TransactionsCashDashboard', permission: 'Reports' },
  ReconciliationDashboard: { feature: 'ReconciliationDashboard', permission: 'Reports' },
  DealsReport: { feature: 'DealsReport', permission: 'Reports' },
  CashLedger: { feature: 'CashLedger', permission: 'Reports' },
  CashLedgerPivot: { feature: 'CashLedgerPivot', permission: 'Reports' },
  Holdings: { feature: 'Holdings', permission: 'Reports' },
  BondHoldings: { feature: 'BondHoldings', permission: 'Reports' },
  TermDeposits: { feature: 'TermDeposits', permission: 'Reports' },
  Loans: { feature: 'Loans', permission: 'Reports' },
  NbaHoldings: { feature: 'NbaHoldings', permission: 'Reports' },
  RealAssetsWorth: { feature: 'RealAssetsWorth', permission: 'Reports' },
  RealAssetsCapitalAccount: { feature: 'RealAssetsCapitalAccount', permission: 'Reports' },
  UpcomingEvents: { feature: 'UpcomingEvents', permission: 'Reports' },
  RealizedGains: { feature: 'RealizedGains', permission: 'Reports' },
  UnrealizedGains: { feature: 'UnrealizedGains', permission: 'Reports' },
  MultiPeriodPLDecomposition: { feature: 'MultiPeriodPLDecomposition', permission: 'Reports' },
  BrowseFeeRules: { feature: 'BrowseFeeRules', permission: 'Read' },
  CreateFeeRule: { feature: 'CreateFeeRule', permission: 'Write' },
  FeeDeviation: { feature: 'FeeDeviation', permission: 'Reports' },
  ReclaimableCharges: { feature: 'ReclaimableCharges', permission: 'Reports' },
  Retrocession: { feature: 'Retrocession', permission: 'Reports' },
  OnboardingDashboard: { feature: 'OnboardingDashboard', permission: 'Reports' },
  OnboardingPipeline: { feature: 'OnboardingPipeline', permission: 'Reports' },
  OnboardingAging: { feature: 'OnboardingAging', permission: 'Reports' },
  ScreeningOutcomes: { feature: 'ScreeningOutcomes', permission: 'Reports' },
  DocumentsStatus: { feature: 'DocumentsStatus', permission: 'Reports' },
  PLAnalytics: { feature: 'PLAnalytics', permission: 'Reports' },
  PLAnalyticsRollupSummary: { feature: 'PLAnalyticsRollupSummary', permission: 'Reports' },
  PerformanceEvolution: { feature: 'PerformanceEvolution', permission: 'Reports' },
  RiskAnalytics: { feature: 'RiskAnalytics', permission: 'Reports' },
  ContributionAnalysis: { feature: 'ContributionAnalysis', permission: 'Reports' },
  CalendarYearReturns: { feature: 'CalendarYearReturns', permission: 'Reports' },
  PositionPerformance: { feature: 'PositionPerformance', permission: 'Reports' },
  RelativePerformance: { feature: 'RelativePerformance', permission: 'Reports' },
  BenchmarkComparison: { feature: 'BenchmarkComparison', permission: 'Reports' },
  ExcessReturnTimeSeries: { feature: 'ExcessReturnTimeSeries', permission: 'Reports' },
  DefineCompositeBenchmark: { feature: 'DefineCompositeBenchmark', permission: 'Write' },
  CrossExposure: { feature: 'CrossExposure', permission: 'Reports' },
  ThematicExposure: { feature: 'ThematicExposure', permission: 'Reports' },
  AssetReconciliation: { feature: 'AssetReconciliation', permission: 'Reports' },
  ReconciliationWorkbench: { feature: 'ReconciliationWorkbench', permission: 'Reports' },
  BondReconciliation: { feature: 'BondReconciliation', permission: 'Reports' },
  UnifiedDashboard: { feature: 'UnifiedDashboard', permission: 'Reports' },
  UnifiedHoldings: { feature: 'UnifiedHoldings', permission: 'Reports' },
  UnifiedCashFlows: { feature: 'UnifiedCashFlows', permission: 'Reports' },
  UnifiedPerformance: { feature: 'UnifiedPerformance', permission: 'Reports' },
  UnifiedTransactions: { feature: 'UnifiedTransactions', permission: 'Reports' },
  ImportHeritage: { feature: 'ImportHeritage', permission: 'Write' },
  ImportJuliusBaer: { feature: 'ImportJuliusBaer', permission: 'Write' },
  ImportJuliusBaerReconciliation: { feature: 'ImportJuliusBaerReconciliation', permission: 'Write' },
  ImportCitibank: { feature: 'ImportCitibank', permission: 'Write' },
  ImportGoldmanSachs: { feature: 'ImportGoldmanSachs', permission: 'Write' },
  ImportJPMorgan: { feature: 'ImportJPMorgan', permission: 'Write' },
  ImportPershing: { feature: 'ImportPershing', permission: 'Write' },
  ImportSocieteGenerale: { feature: 'ImportSocieteGenerale', permission: 'Write' },
  ImportSafra: { feature: 'ImportSafra', permission: 'Write' },
  ImportDegroofPetercam: { feature: 'ImportDegroofPetercam', permission: 'Write' },
  ImportBloomberg: { feature: 'ImportBloomberg', permission: 'Write' },
  ImportMarketDataPrices: { feature: 'ImportMarketDataPrices', permission: 'Write' },
  ImportForexRates: { feature: 'ImportForexRates', permission: 'Write' },
  SearchExchanges: { feature: 'SearchExchanges', permission: 'Read' },
  CreateExchange: { feature: 'CreateExchange', permission: 'Write' },
  ImportCommands: { feature: 'ImportCommands', permission: 'Admin' },
  SignalRLogs: { feature: 'SignalRLogs', permission: 'Admin' },
  TimeTravel: { feature: 'TimeTravel', permission: 'Admin' },
  AiActivityConsole: { feature: 'AiActivityConsole', permission: 'Admin' },
  CommandHistory: { feature: 'CommandHistory', permission: 'Admin' },
  NotificationHistory: { feature: 'NotificationHistory', permission: 'Admin' },
  EntitlementsAdmin: { feature: 'EntitlementsAdmin', permission: 'Admin' },
  TenantUserAdmin: { feature: 'TenantUserAdmin', permission: 'Write' },
  ReportingStructureEditor: { feature: 'ReportingStructureEditor', permission: 'Read' },
  DataSeeding: { feature: 'DataSeeding', permission: 'Admin' },
  UserSettings: { feature: 'UserSettings', permission: 'None' },
  Login: { feature: 'Login', permission: 'None' },
  Register: { feature: 'Register', permission: 'Admin' },
};

export function lookupNavigationCommand(wpfKey: string | undefined): NavigationCommandMeta | undefined {
  if (!wpfKey) return undefined;
  return NAVIGATION_COMMAND_REGISTRY[wpfKey];
}
